module.exports = __webpack_public_path__ + "img/shape-6.7a7ab85a.png";